import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

type CleanUp = () => void

export const useCleanUpExtension = () => {
  const componentWillUnmount = useRef(false)

  useEffect(() => {
    return () => {
      componentWillUnmount.current = true
    }
  }, [])

  const [cleanUpList, setCleanUpList] = useState<CleanUp[]>([])

  const subscribe = useCallback((fn: CleanUp) => {
    setCleanUpList((currentCleanUpList) => [...currentCleanUpList, fn])
  }, [])

  const clear = useCallback((fn: CleanUp) => {
    setCleanUpList((currentCleanUpList) =>
      currentCleanUpList.filter((cleanUp) => {
        cleanUp !== fn
      })
    )
  }, [])

  useEffect(
    () => () => {
      if (componentWillUnmount.current) {
        cleanUpList.forEach((fn) => fn())
        setCleanUpList([])
      }
    },
    [cleanUpList]
  )

  return useMemo(() => ({ subscribe, clear }), [subscribe, clear])
}
